import { Box, Chip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useDialog } from 'hooks';

const getGoogleMapsSearchUrl = (location) => {
  if (!location) return '';

  const { street = '', suburb = '', city = '' } = location;
  const query = `${street}, ${suburb}, ${city}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};

export function ChipButton({ locations = [] }) {
  const { select } = useDialog();
  const primary = locations[0];
  const additionalCount = locations.length - 1;

  const handleOpenModal = async () => {
    const locationOptions = locations.map((loc, index) => ({
      label: `${loc.street}, ${loc.suburb}, ${loc.city}`,
      value: index,
    }));

    const result = await select({
      title: "Restaurant Locations",
      options: locationOptions,
    });

    if (result !== null && result !== undefined) {
      const selectedLocation = locations[result.value];
      if (selectedLocation) {
        const url = getGoogleMapsSearchUrl(selectedLocation);
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  };

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {primary && (
        <a
          href={getGoogleMapsSearchUrl(primary)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <Chip
            icon={<LocationOnIcon fontSize="small" />}
            label={`${primary.street}, ${primary.suburb}`}
            size="small"
            clickable
            sx={{ maxWidth: '100%' }}
          />
        </a>
      )}

      {additionalCount > 0 && (
        <Chip
          label={`+${additionalCount} more`}
          size="small"
          variant="outlined"
          clickable
          onClick={handleOpenModal}
        />
      )}
    </Box>
  );
}